/* All-fireplaces presentation. VF36-specific equipment facts remain exact-handle scoped. Original options, variant resolution,
   required flags, prices, cart listeners and order properties stay authoritative. */
(function () {
  'use strict';
  var HANDLE = 'empire-boulevard-36-vent-free-linear-gas-fireplace-vflb36fp';
  function boot() {
    var root = document.querySelector('.ef-lab-fireplace-page #efOf');
    if (!root || root.dataset.efSimplePilot) return;
    function ready() { return root.dataset.efFamilyLayout === 'continuous' && root.querySelector('#efOfTotal'); }
    if (ready()) init(root);
    else {
      var pending = new MutationObserver(function () { if (ready()) { pending.disconnect(); init(root); } });
      pending.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-ef-family-layout'] });
    }
  }
  function init(root) {
    root.dataset.efSimplePilot = 'all-fireplaces-v1';
    var isVF36 = root.dataset.productHandle === HANDLE;
    var productHandle = root.dataset.productHandle;
    var page = root.closest('.ef-lab-fireplace-page');
    page.classList.add('ef-simple-pilot-page');
    var header = root.querySelector('.ef-family-flow__header');
    var fuel = root.querySelector('#efOfCd_fuel');
    var ignition = root.querySelector('#efOfCd_ignition');
    var total = root.querySelector('#efOfTotal');
    var required = root.querySelector('.ef-lab-fireplace-required');
    var extras = root.querySelector('.ef-lab-fireplace-extras');
    function el(tag, className, text) {
      var node = document.createElement(tag); node.className = className;
      if (text) node.textContent = text; return node;
    }
    function copy(node, text) { if (node && node.textContent !== text) node.textContent = text; }
    function heading(id, title, hint, before) {
      var box = el('div', 'ef-simple-step'); box.id = id;
      var h = el('h3', 'ef-simple-step__title', title); h.tabIndex = -1;
      box.append(h, el('p', 'ef-simple-step__hint', hint)); before.before(box); return box;
    }
    var firstNativeField = Array.from(root.querySelectorAll('.ef-of__cd')).map(function(d) { return d.closest('fieldset'); }).find(function(f) { return f && f.parentElement === root; });
    var one = heading('ef-simple-choices', '1. Choose your options', 'Choose the options for this model. Each option card shows the matching fireplace price; additions are itemized below.', firstNativeField || required || extras || total);
    var model = el('p', 'ef-simple-step__hint', root.dataset.productTitle || 'Review this fireplace model.'); one.append(model);
    var two = heading('ef-simple-equipment', '2. Equipment & extras', 'Review the equipment and any additions you want.', required || extras || total);
    var included = el('div', 'ef-simple-included');
    included.hidden = !isVF36;
    included.append(el('strong', '', 'A remote is included'));
    var includedText = el('p', ''); included.append(includedText);
    two.append(included);
    two.append(el('p', 'ef-simple-step__hint', isVF36 ? 'Confirm that a vent-free fireplace is permitted and suitable for your installation. Your installer must check the manufacturer requirements.' : 'Check the manufacturer documents for included equipment and installation requirements. Required selections are marked below.'));
    var three = heading('ef-simple-review', '3. Review your selections', 'Check your model, options and selected additions before adding to cart.', total);
    var review = el('div', 'ef-simple-review'); three.append(review);
    var scope = el('p', 'ef-simple-price-scope', 'Equipment subtotal for the selections above. Installation is not included. Any applicable tax and delivery charges are shown at checkout.');
    total.after(scope);
    var nav = el('nav', 'ef-simple-nav'); nav.setAttribute('aria-label', 'Your fireplace order');
    [[one,'Options'],[two,'Equipment'],[three,'Review']].forEach(function (entry, i) {
      var a = el('a', '', (i + 1) + '. ' + entry[1]); a.href = '#' + entry[0].id;
      a.addEventListener('click', function (event) { event.preventDefault(); entry[0].querySelector('h3').focus(); entry[0].scrollIntoView({ block: 'start' }); });
      nav.append(a);
    });
    if (header) {
      header.append(nav);
      var help = el('a', 'ef-simple-help', 'Not sure? Talk to a fireplace specialist'); help.href = '#ef-family-help';
      help.addEventListener('click', function (event) {
        var target = page.querySelector('#ef-family-help');
        if (target) { event.preventDefault(); target.scrollIntoView({ block: 'start' }); var link = target.querySelector('a'); if (link) link.focus({ preventScroll: true }); }
      }); header.append(help);
    }
    // Move the existing expert component, keeping its routes and listeners intact.
    var expert = page.querySelector('.ef-fireplace-early-help');
    if (expert) root.after(expert);
    var notes = root.querySelector('.ef-lab-fireplace-notes');
    if (notes) three.before(notes);
    var signature = null;
    function visible(d) {
      var f = d.closest('fieldset');
      if (!f || !d.querySelector('.ef-of__cd-opt')) return false;
      // Closed optional disclosures are still editable choices; hidden groups are not.
      for (var n = f; n && n !== root; n = n.parentElement) {
        if (n.hidden || getComputedStyle(n).display === 'none') return false;
      }
      return true;
    }
    function edit(d) {
      var ancestor = d.parentElement.closest('details');
      while (ancestor && root.contains(ancestor)) { ancestor.open = true; ancestor = ancestor.parentElement.closest('details'); }
      d.open = true; var summary = d.querySelector('summary');
      if (summary) summary.focus({ preventScroll: true }); d.scrollIntoView({ block: 'center' });
    }
    function update() {
      // Native option-card prices must reflect the other currently selected axis.
      // Show the actual matched fireplace price, never a guessed additive delta.
      // This reads Shopify's emitted matrix; it does not change pricing/state data.
      var matrix = window.EF_GL && window.EF_GL[productHandle];
      if (matrix && matrix.options && matrix.variants) {
        var chosen = matrix.options.map(function (axis) {
          var d = root.querySelector('.ef-of__cd[data-group="' + axis.key + '"]');
          var card = d && d.querySelector('.ef-of__cd-opt[aria-selected="true"]');
          return card ? card.dataset.rawLabel || card.dataset.label : null;
        });
        matrix.options.forEach(function (axis, axisIndex) {
          var detail = root.querySelector('.ef-of__cd[data-group="' + axis.key + '"]');
          if (!detail) return;
          detail.querySelectorAll('.ef-of__cd-opt').forEach(function (card) {
            var candidate = card.dataset.rawLabel || card.dataset.label;
            var match = matrix.variants.find(function (v) { return v.opts.every(function (value, index) { return value === (index === axisIndex ? candidate : chosen[index]); }); });
            var price = card.querySelector('.ef-cfg-card__price');
            if (!price) { price = el('span', 'ef-cfg-card__price'); (card.querySelector('.ef-cfg-card__body') || card).append(price); }
            price.classList.remove('ef-cfg-card__price--inc');
            var hasPrice = match && typeof match.price === 'number' && Number.isFinite(match.price) && match.price >= 0;
            var otherChosen = chosen.every(function (value, index) { return index === axisIndex || value !== null; });
            copy(price, hasPrice && match.available !== false ? 'Fireplace: ' + (match.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: match.price % 100 ? 2 : 0, maximumFractionDigits: 2 }) : !otherChosen ? 'Choose the other option to see the price' : 'Price unavailable for this selection');
          });
        });
      }
      if (isVF36) {
      var label = ignition && ignition.querySelector('.ef-of__cd-selected-label');
      var isIpi = label && /electronic|ipi/i.test(label.textContent);
      var confirmedIgnition = ignition && ignition.dataset.selected === 'true';
      copy(includedText, !confirmedIgnition ? 'Both controls include a remote: FRBC on/off with Millivolt, or Proflame thermostat and variable-flame control with Electronic (IPI).' : isIpi ? 'Electronic (IPI): Proflame remote with thermostat and variable-flame control. No additional remote is needed.' : 'Millivolt: FRBC on/off remote and receiver. No additional remote is needed.');
      var remote = root.querySelector('#efOfCd_remote');
      if (remote) {
        var none = remote.querySelector('.ef-of__cd-opt[data-label="None"]');
        if (none) copy(none.querySelector('.ef-cfg-card__title'), 'Included remote — no additional control');
        var selected = remote.querySelector('.ef-of__cd-selected-label');
        var current = remote.querySelector('.ef-of__cd-opt[aria-selected="true"]');
        if (current && current.dataset.label === 'None') copy(selected, 'Included remote — no additional control');
        var remoteField = remote.closest('fieldset');
        var note = remoteField.querySelector('.ef-simple-control-note');
        if (!note) { note = el('p', 'ef-simple-control-note'); remote.before(note); }
        copy(note, 'Your selected fireplace already includes the remote described above. Additional controls are optional; check compatibility with your ignition before choosing one.');
      }
      // Correct only visible model-specific explanations, never option data or state.
      if (ignition) {
        ignition.querySelectorAll('.ef-of__cd-opt').forEach(function (card) {
          var text = /electronic|ipi/i.test(card.dataset.label) ? 'Includes a Proflame thermostat and variable-flame remote.' : 'Includes an FRBC on/off remote and receiver.';
          copy(card.querySelector('.ef-cfg-card__desc'), text);
        });
        if (confirmedIgnition) copy(ignition.querySelector('.ef-of__cd-selected-desc'), isIpi ? 'Includes a Proflame thermostat and variable-flame remote.' : 'Includes an FRBC on/off remote and receiver.');
      }
      }
      var fields = Array.from(root.querySelectorAll('.ef-of__cd')).filter(visible);
      var nativeKeys = matrix && Array.isArray(matrix.options) ? matrix.options.map(function(axis) { return axis.key; }) : [];
      var nativeFields = fields.filter(function(d) { return nativeKeys.indexOf(d.dataset.group) !== -1; });
      var hasEquipment = fields.some(function(d) { return nativeKeys.indexOf(d.dataset.group) === -1; });
      var oneTitle = one.querySelector('h3');
      copy(oneTitle, nativeFields.length ? (fuel && ignition && visible(fuel) && visible(ignition) && nativeFields.length === 2 ? '1. Fuel & control' : '1. Choose your options') : '1. Your fireplace');
      var hideModel = nativeFields.length > 0;
      if (model.hidden !== hideModel) model.hidden = hideModel;
      copy(one.querySelector('.ef-simple-step__hint'), nativeFields.length ? 'Choose the options for this model. Each option card shows the matching fireplace price; additions are itemized below.' : 'Review this model and its equipment and installation requirements below.');
      // Single-SKU models keep useful equipment guidance without empty dropdowns.
      copy(two.querySelector('.ef-simple-step__hint'), hasEquipment ? 'Review required selections and any additions you want.' : 'Review the manufacturer documents and confirm what your installation needs.');
      var rows = fields.filter(function (d) { var selected = d.querySelector('.ef-of__cd-opt[aria-selected="true"]');
        return d.dataset.required === 'true' || nativeKeys.indexOf(d.dataset.group) !== -1 || (selected && ((selected.dataset.variantId || '') !== '' || !/^(none|no|not selected)$/i.test((selected.dataset.rawLabel || selected.dataset.label || '').trim()))); }).map(function (d) {
        var originalLegend = d.closest('fieldset').querySelector('legend');
        var legend = originalLegend ? originalLegend.cloneNode(true) : el('span', '', d.dataset.group);
        legend.querySelectorAll('.ef-fireplace-required,.ef-of__legend-num').forEach(function (n) { n.remove(); });
        var selected = d.querySelector('.ef-of__cd-selected-label');
        return { d: d, label: legend.textContent.trim(), value: d.dataset.selected === 'true' && selected ? selected.textContent : 'Choose an option' };
      });
      var next = JSON.stringify(rows.map(function (r) { return [r.d.id,r.label,r.value]; }));
      if (next !== signature) {
        signature = next; review.replaceChildren();
        if (!rows.length) review.append(el('p', 'ef-simple-review__model', root.dataset.productTitle || 'Your selected fireplace'));
        rows.forEach(function (r) {
          var row = el('div', 'ef-simple-review__row');
          var words = el('div', ''); words.append(el('span', 'ef-simple-review__label', r.label), el('strong', '', r.value));
          var button = el('button', 'ef-simple-edit', 'Edit'); button.type = 'button'; button.setAttribute('aria-label', 'Edit ' + r.label);
          button.addEventListener('click', function () { edit(r.d); }); row.append(words, button); review.append(row);
        });
      }
    }
    // After the existing engine reports a validation error, focus its first missing
    // field. No second purchase handler, no synthetic selection and no cart calls.
    root.addEventListener('click', function (event) {
      if (!event.target.closest('#efOfAtc,#efOfExpressCheckout')) return;
      var message = root.querySelector('#efOfMsg');
      var missing = Array.from(root.querySelectorAll('.ef-of__cd[data-required="true"]:not([data-selected="true"])')).find(visible);
      if (missing && message && !message.hidden) requestAnimationFrame(function () { edit(missing); });
    });
    update();
    var queued = false;
    new MutationObserver(function () {
      if (queued) return; queued = true;
      requestAnimationFrame(function () { queued = false; update(); });
    }).observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-selected','data-required','aria-selected','hidden','style'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
